// src/ProductList.jsx
import React from "react"
import ProductItem from "./ProductItem"

/**
 * Container component for product list in planner
 */
const ProductList = ({
  productNodes,
  selectProductNodeInstance,
  removeProductNodeInstance,
  duplicateProductNode,
  rotateProductNodeInstance,
  changeProductNodeInstanceHeight,
  applyMaterial,
  materials,
  wood,
  labels,
}) => {
  // If no products, show message
  if (Object.keys(productNodes).length === 0) {
    return (
      <div className="ay-text-center ay-py-4 ay-text-gray-500">
        {labels.noProducts}
      </div>
    )
  }

  // Group products by project code for better organization
  const groupedProducts = {}
  Object.values(productNodes).forEach((pn) => {
    const key = pn.projectCode
    if (!groupedProducts[key]) {
      groupedProducts[key] = []
    }
    groupedProducts[key].push(pn)
  })

  return (
    <div>
      {Object.entries(groupedProducts).map(([projectCode, products]) => (
        <div key={projectCode}>
          {products.map((pn) => (
            <ProductItem
              key={pn.localId}
              pn={pn}
              selectProductNodeInstance={selectProductNodeInstance}
              removeProductNodeInstance={removeProductNodeInstance}
              duplicateProductNode={duplicateProductNode}
              rotateProductNodeInstance={rotateProductNodeInstance}
              changeProductNodeInstanceHeight={changeProductNodeInstanceHeight}
              applyMaterial={applyMaterial}
              materials={materials}
              wood={wood}
              labels={labels}
            />
          ))}
        </div>
      ))}
    </div>
  )
}

export default ProductList
